/**
 * Mileage routing (§A6g) — POST /geo/route computes per-leg driving miles +
 * route geometry via Azure Maps (server-side). Used by the mileage calculator.
 */
import { useMutation } from '@tanstack/react-query';
import type { RouteRequest, RouteResponse } from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

export function useRouteLegs() {
  return useMutation<RouteResponse, Error, RouteRequest>({
    mutationFn: (body) => apiCall<RouteResponse>('/geo/route', { method: 'POST', body }),
  });
}
